import { Skeleton as MuiSkeleton } from '@mui/material';

export const Skeleton = MuiSkeleton;
export type { SkeletonProps } from '@mui/material';
